import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Request } from './request';
import { environment } from '../../../environments/environment';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private readonly API = `${environment.API}/`;

  constructor(
    private httpClient: HttpClient,
    private platformLocation: PlatformLocation,
  ) { }

  get(request: Request) {
    if (typeof request.data !== 'undefined') {
      const returnPromise = this.httpClient.get(this.API + request.url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        params: Object.getOwnPropertyNames(request.data)
          .reduce((p, key) => p.set(key, request.data[key]), new HttpParams())
      })
      .toPromise().then(
        res => {
          request.successAction(res);
        },
        msg => request.errorAction(msg));
      return returnPromise;
    } else {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };
      const returnPromise = this.httpClient.get(this.API + request.url, options).toPromise().then(
        res => {
          request.successAction(res);
        },
        msg => request.errorAction(msg));
      return returnPromise;
    }

  }

  post(request: Request) {
    const authorization = localStorage.getItem('rbScheduleAdmToken');
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization: authorization ? 'Bearer ' + authorization : '',
      })
    };

    // if (request.data && typeof request.data === 'object') {
    //   request.data.url = this.platformLocation.href;
    // } else {
    //   request.data = {
    //     url: this.platformLocation.href
    //   };
    // }

    const promise = this.httpClient.post( this.API + request.url, request.data, options).toPromise().then(
      res => {
        request.successAction(res);
      },
      msg => request.errorAction(msg));
    return promise;
  }

  del(request: Request) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization: 'Bearer ' + localStorage.getItem('rbScheduleAdmToken'),
      })
    };

    const promise = this.httpClient.delete( this.API + request.url + '/' + request.data.id, options).toPromise().then(
      res => request.successAction(res),
      msg => request.errorAction(msg));
    return promise;
  }

  put(request: Request) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // Authorization: 'Bearer ' + localStorage.getItem('rbScheduleAdmToken'),
      })
    };

    // if (request.data && typeof request.data === 'object') {
    //   request.data.url = this.platformLocation.href;
    // } else {
    //   request.data = {
    //     url: this.platformLocation.href
    //   };
    // }

    const promise = this.httpClient.put( this.API + request.url, request.data, options).toPromise().then(
      res => request.successAction(res),
      msg => request.errorAction(msg));
    return promise;
  }

  createParams(data: {}) {
    let httpParams = new HttpParams();
    for ( const key in data) {
      if ( typeof data[key] === 'object') {
        for (const obj of data[key]) {
          httpParams = httpParams.append(key + '[]', obj);
        }
      } else {
        httpParams = httpParams.set(key, data[key]);
      }
    }
    return httpParams;
  }


  postFile(request: Request) {

    const promise = this.httpClient.post(this.API + request.url, this.createParamsPostFile(request.data))
    .toPromise().then(
      res => request.successAction(res),
      msg => request.errorAction(msg));
    return promise;
  }

  createParamsPostFile(data: {}) {
    const httpParams = new FormData();

    for ( const key in data) {
      if (data.hasOwnProperty(key)) {
        httpParams.append(key, data[key]);
      }
    }
    return httpParams;
  }

}
